import { useQuery } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TApiResponse } from '@shared/types';
import type { BillingInterval, TPlanApi, TPlanPrice } from '@shared/types/plan';

export const getPlansList = async (): Promise<TApiResponse<TPlanApi>> => {
  return request({
    url: 'plans/',
  });
};

export const useGetPlansList = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.getPlansList],
    queryFn: async () => await getPlansList(),
    staleTime: Infinity,
    select: (data) => {
      return data.results.map((plan: TPlanApi) => {
        const mappedPrices: Record<BillingInterval, TPlanPrice> = (
          plan.prices as unknown as TPlanPrice[]
        )?.reduce(
          (acc: Record<BillingInterval, TPlanPrice>, price: TPlanPrice) => {
            acc[price.billing_interval as BillingInterval] = price;
            return acc;
          },
          {} as Record<BillingInterval, TPlanPrice>
        );
        return {
          ...plan,
          prices: mappedPrices,
        };
      });
    },
  });
};
